<script setup lang="ts"></script>

<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.79299 5.29289C10.1835 4.90237 10.8167 4.90237 11.2072 5.29289C11.5977 5.68342 11.5977 6.31658 11.2072 6.70711L6.91431 11H19.5001C20.0524 11 20.5001 11.4477 20.5001 12C20.5001 12.5523 20.0524 13 19.5001 13H6.91431L11.2072 17.2929C11.5977 17.6834 11.5977 18.3166 11.2072 18.7071C10.8167 19.0976 10.1835 19.0976 9.79299 18.7071L4.50009 13.4142C3.71904 12.6332 3.71904 11.3668 4.50009 10.5858L9.79299 5.29289Z"
      fill="currentColor"
    />
  </svg>
</template>
